import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * Representa un producto de importación que puede ser editado.
 */
export interface ImportProductForEdit {
  id: number;              // ID del detalle de producto
  productId: number;       // ID del producto
  productName: string;     // Nombre del producto
  quantity: number;        // Cantidad comprada
  amount: number;          // Monto total del producto
  unit: string;            // Unidad de medida
  category: string;        // Categoría del producto
}

/**
 * Estado global para gestionar productos en compras de importación.
 */
interface ImportPurchaseState {
  productToEdit: ImportProductForEdit | null;  // Producto seleccionado para edición
  showAddProductModal: boolean;                // Estado del modal de agregar
  showEditProductModal: boolean;               // Estado del modal de edición
}

// Estado inicial
const initialState: ImportPurchaseState = {
  productToEdit: null,
  showAddProductModal: false,
  showEditProductModal: false
};

/**
 * Slice de Redux para manejar la lógica de UI y edición de productos de importación.
 */
const importPurchaseSlice = createSlice({
  name: 'importPurchase',
  initialState,
  reducers: {
    /**
     * Establece el producto que se desea editar.
     *
     * @param action - Producto de tipo `ImportProductForEdit`
     */
    setProductToEdit(state, action: PayloadAction<ImportProductForEdit>) {
      state.productToEdit = action.payload;
    },

    /**
     * Limpia el producto seleccionado para edición.
     */
    clearProductToEdit(state) {
      state.productToEdit = null;
    },

     /**
     * Abre el modal para agregar un nuevo producto.
     */
    openAddProductModal(state) {
      state.showAddProductModal = true;
    },

    /**
     * Cierra el modal para agregar producto.
     */
    closeAddProductModal(state) {
      state.showAddProductModal = false;
    },

    /**
     * Abre el modal para editar un producto existente.
     */
    openEditProductModal(state) {
      state.showEditProductModal = true;
    },

    /**
     * Cierra el modal de edición de producto.
     */
    closeEditProductModal(state) {
      state.showEditProductModal = false;
    },
  },
});

export const { 
  setProductToEdit, 
  clearProductToEdit,
  openAddProductModal,
  closeAddProductModal,
  openEditProductModal,
  closeEditProductModal
} = importPurchaseSlice.actions;
export default importPurchaseSlice.reducer;
